import { AppIconKey } from "./icons";

export interface PromptButtonConfig {
  title: string;
  helpText: string;
  prompt: string;
  iconKey: AppIconKey;
}

/**
 * Prompt button configs shown on the empty-state welcome screen.
 * - title    : short label displayed on the button
 * - helpText : secondary line shown beneath the title
 * - prompt   : the full message sent to the agent when the button is clicked
 * - iconKey  : key into AppIcons (see constants/icons.ts)
 */
export const PROMPT_BUTTONS: PromptButtonConfig[] = [
  {
    title: "Analyse data",
    helpText: "Query and explore my metrics",
    prompt:
      "I want to analyse my data. Ask me what business question I am trying to answer, " +
      "which metrics and dimensions are relevant, and what time period to look at. " +
      "Then fetch the data and compute whatever is needed to answer the question.",
    iconKey: "analyseData",
  },
  {
    title: "Build a chart",
    helpText: "Visualise metrics as a chart",
    prompt:
      "I want to create a chart. Ask me what metrics I want to visualise, what time period, " +
      "and how I want to group or slice the data. Then build the chart.",
    iconKey: "buildChart",
  },
  {
    title: "Build a workflow",
    helpText: "Set up a recurring scheduled analysis",
    prompt:
      "I want to set up a workflow which may run automatically on a schedule. " +
      "Ask me what analysis I want to run, if and how often I want to schedule it. " +
      "Then execute a sample run and confirm with me before saving.",
    iconKey: "workflow",
  },
  {
    title: "Run a workflow",
    helpText: "Execute a saved workflow now",
    prompt:
      "I want to run one of my existing saved workflows. Show me the list of available workflows " +
      "and ask me which one to run. Once finished with execution, check if you need to save the output.",
    iconKey: "runWorkflow",
  },
];
